import { IntlShape } from 'react-intl';
import { AttendeeAttendanceMethod, IAttendeeAttendanceMethod, PodiumQuestionAnswerPriorityType } from '../api/attendees.dao';

const attendanceMethods = (intl: IntlShape): IAttendeeAttendanceMethod[] => [
    {
        value: AttendeeAttendanceMethod.IN_PERSON,
        label: intl.formatMessage({
            id: 'oe.attendee.attendanceMethod.inPerson',
            description: 'Label text',
            defaultMessage: 'In Person',
        })
    },
    {
        value: AttendeeAttendanceMethod.VIRTUAL,
        label: intl.formatMessage({
            id: 'oe.attendee.attendanceMethod.virtual',
            description: 'Label text',
            defaultMessage: 'Virtual',
        })
    },
    {
        value: AttendeeAttendanceMethod.BOTH,
        label: intl.formatMessage({
            id: 'oe.attendee.attendanceMethod.both',
            description: 'Label text',
            defaultMessage: 'Both',
        })
    }
];

const attendeeQAPriorityOptions = (intl: IntlShape): { value: PodiumQuestionAnswerPriorityType | string; label: string }[] => [
    {
        value: '',
        label: intl.formatMessage({
            id: 'oe.attendee.podiumQAPriorityNotSelected',
            description: 'Label text',
            defaultMessage: 'No Q&A Priority selected',
        })
    },
    {
        value: PodiumQuestionAnswerPriorityType.STAR,
        label: intl.formatMessage({
            id: 'oe.attendee.podiumQAPriorityStar',
            description: 'Label text',
            defaultMessage: 'Star',
        })
    },
    {
        value: PodiumQuestionAnswerPriorityType.RED_FLAG,
        label: intl.formatMessage({
            id: 'oe.attendee.podiumQAPriorityRedFlag',
            description: 'Label text',
            defaultMessage: 'Red Flag',
        })
    }
];

export {
    attendanceMethods,
    attendeeQAPriorityOptions
};